{
  "translation": {
    "attribute photo": "Фото зделано {{author}} на {{platform}}.",
    "home": {
      "welcome to": "Добро Пожаловать в {{name}}.",
      "start": "Начинать",
      "why": {
        "why": "Зачем {{name}}?",
        "1": "Находит самое еффективное место для ваших солнечных панель.",
        "2": "Оценивает расходы в будушем",
        "3": "включает в калкуляцие широту углы и.т.д",
        "4": "включает в калкуляцие широту углы и.т.д"
      }
    },
    "404": {
      "not found": "Страница не наидена",
      "go home": "Домой"
    },
    "about": {
      "title": "Про",
      "repo": "Посмотрите код на гитхабе.",
      "changelog": "Посмотрите старые версии.",
      "made with": "Зделано используя ",
      "authors": "Зделано используя <0></0> {{authors}}",
      "exit": "Щелкните в любом месте, чтобы выйти."
    },
    "planner": {
      "next step": "Следуишяе",
      "location": {
        "title": "Сетап места",
        "latitude": "широта вашего здания.",
        "shading": "насколько затенена ваша крыша.",
        "direction": "на каком угле ваш дом."
      },
      "finance": {
        "title": "Выбирайте солнечные панели",
        "energy usage": "сколько електричества вы используете в год",
        "energy cost": "Цена Енергий за 1kw/h",
        "seg": "сколько вам платят за 1kw/h електричества",
        "seg info": "Что Такое Умная Експортная Гарантия?",
        "seg desc": "Умная Експортная Гарантия это умная схема заделана правительством чтобы вам платить бабки за ваше електричество.",
        "energy info": "Как наитй сколько мне должны платить?",
        "energy desc": "Твоя компания должна на вебсайте показывать или если нету посмотрите ваши платежи ну да."
      },
      "roof": {
        "title": "выбираите солнечные панели",
        "add section": "добавить секцию"
      },
      "overview": {
        "title": "выбираите солнечные панели и веши",
        "panels": "Панели",
        "overview": "Обзор",
        "roof area": "Плошадь: {{area}}",
        "panel area_one": "Плошадь Панель: {{area}}m² ({{count}} Панель, <0>{{efficiency}}% Еффективность</0>)",
        "panel area_other": "Плошадь Панель: {{area}}m² ({{count}} Панелеи, <0>{{efficiency}}% Еффективность</0>)",
        "initial cost": "Начальная цена: £{{cost}}",
        "labor cost": "стоимость рабочих: £{{cost}}",
        "estimated energy": "Енергия: {{energy}} {{efficiency}}",
        "annual energy": "Енергия в Год: {{energy}}kWh",
        "annual profits": "Доход в Год: £{{profit}}",
        "return on investment": "Время Денег Обратно: {{roi}} years",
        "annual savings": "Зберегание В Год: £{{saving}}",
        "best": "лучшие денги",
        "error no sections": "Нету секции",
        "error no space": "не достаточно места"
      }
    },
    "common": {
      "tagline": "Самые умные в етом класе",
      "latitude": "широта",
      "shading": "затенение",
      "direction": "Угол",
      "energy usage": "Енергия",
      "energy cost": "Цена Енергий",
      "seg": "Умная експортная гарантия",
      "width": "ширина",
      "height": "высота",
      "gradient": "градиент",
      "dimensions": "размеры",
      "area": "плошадь",
      "price": "Цена"
    },
    "adjs": {
      "none": "Ничего",
      "little": "очень мало",
      "modest": "Средниё",
      "significant": "значительное",
      "heavy": "Сильно Затемненоё",
      "full": "Полностью затёмнено"
    },
    "geo": {
      "northern": "северная хемисфера",
      "southern": "южная хемисфера",
      "equator": "екватор",
      "n": "север",
      "ne": "северо-восток",
      "e": "восток",
      "se": "юговосток",
      "s": "юг",
      "sw": "югозапад",
      "w": "запад",
      "nw": "северозапад"
    }
  }
}
